module.exports = __webpack_public_path__ + "img/docu_sign.f741add0.svg";